"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
function initLivestream(id, channel) {
    return {
        id: id,
        channel_id: channel.id,
        name: '',
        livestream_id: '',
        ingest: '',
        ingest_name: '',
        channel_type: channel.type,
        publish: true,
        type: '',
        source_path: '',
        pullzone_id: '',
        auto: true,
        video: initVideo(),
    };
}
function initVideo() {
    return {
        id: null,
        slug: '',
        description: '',
        category_id: '',
        status: '',
        hidden: true,
        options: {
            enabled: false,
            amount: 0,
            chat: false,
            highlights: false,
            comments: true,
            viewers: true,
        },
        external_id: '',
        thumbnail: '',
        match_location: '',
        team_id: '',
        opponent_id: '',
        team_score: '',
        opponent_score: '',
        date: '',
        src: '',
        plans: [],
        hash: '',
        viewers: 0,
    };
}
function params(id, channel) {
    return {
        id: id,
        channel_id: channel.id,
        details: true,
        include_hash: true,
        media: true,
    };
}
var mapping = {
    channel_id: 'channel.id',
    type: 'type.name',
};
function Edit(_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var _b = react_1.useState(false), changed = _b[0], setChanged = _b[1];
    var _c = react_1.useState(initVideo()), videoPoll = _c[0], setVideoPoll = _c[1];
    var _d = ra_fetch_1.useApi('backend')
        .mapping(mapping)
        .update('livestreams', initLivestream(id, channel), params(id, channel)), livestream = _d[0], setLivestream = _d[1], saveLivestream = _d[2];
    react_1.useEffect(function () {
        setVideoPoll(livestream.data.video);
    }, [livestream.data.video.id]);
    function onSubmit() {
        var video = __assign({}, livestream.data.video);
        delete video.status;
        saveLivestream({ video: video }).then(function () {
            setChanged(true);
        });
    }
    function toggleVideoOption(field) {
        var _a;
        var video = __assign(__assign({}, livestream.data.video), { options: __assign(__assign({}, livestream.data.video.options), (_a = {}, _a[field] = !livestream.data.video.options[field], _a)) });
        delete video.status;
        setLivestream({ video: video });
        ra_fetch_1.Fetcher.api('backend').update('livestreams', {
            id: livestream.data.id,
            video: video,
            channel_id: channel.id,
        });
    }
    function setLivestreamVideo(video) {
        setLivestream({ video: __assign(__assign({}, livestream.data.video), video) });
    }
    if (livestream.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!livestream.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.ContainerWithSidebar, { className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Layouts.Main, null,
                    react_1.default.createElement(storybook_1.Videos.FormPlayer, { user: user, channel: channel, id: livestream.data.id, video: __assign(__assign({}, videoPoll), { type: 'live' }), setVideo: function (video) {
                            setVideoPoll(__assign(__assign({}, videoPoll), { status: video.status, external_id: video.external_id, src: video.src, viewers: video.viewers }));
                        } }),
                    react_1.default.createElement(storybook_1.Livestreams.Form, { video: livestream.data.video, livestream: livestream, setLivestream: setLivestream, setVideo: setLivestreamVideo, toggleVideoOption: toggleVideoOption, user: user, channel: channel, submit: onSubmit })),
                react_1.default.createElement(storybook_1.Livestreams.FormSidebar, { toggleVideoOption: toggleVideoOption, livestream: livestream.data, setLivestream: setLivestream, video: __assign(__assign({}, livestream.data.video), { status: videoPoll.status }), setVideo: setLivestreamVideo, changed: changed, setChanged: setChanged }))));
}
exports.default = Edit;
Edit.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Current channel
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Livestream ID for editing.
     */
    id: prop_types_1.default.number.isRequired,
};
